import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText, DropdownItem} from 'reactstrap';

import '../html/fontawesome/css/all.min.css'

import MagstimDropdown from './MagstimDropdown'
import MagstimPropertyCard from './MagstimPropertyCard'

import { styles } from "./magstim"
import { MagstimColor } from "./../Magstim.Color";

import * as StringUtils from '../utils/StringUtils.js'
import { CurrentLang } from '../utils/LocalisationUtils';
import { CurrentTheme } from "common/utils/ThemeUtils";

class MagstimTreatmentSummary extends React.Component {

    state = {
        name: ""
    };

    constructor() {
        super();
        this._inputManualLocation = React.createRef();
        this._dropdownStimGuideLocation = React.createRef();
    }

    // eslint-disable-next-line no-unused-vars
    onChangeManualLocation = (event) => {
        if ((undefined !== this.props.onChangeManualLocation) && (null !== this.props.onChangeManualLocation)) {
            this.props.onChangeManualLocation(this.props.index, this._inputManualLocation.current.value);
        }
    }

    onChangeStimGuideLocation = (id) => {
        if ((undefined !== this.props.onChangeStimGuideLocation) && (null !== this.props.onChangeStimGuideLocation)) {
            this.props.onChangeStimGuideLocation(this.props.index, this.props.stimguideLocations[Number(id)]);
        }
    }

    getNamedValuePairs(data) {
        return [
            { name: CurrentLang().treatment_summary_card_pcRMT, value: StringUtils.formatPercent(data.pcRMT) },
            { name: CurrentLang().treatment_summary_card_pps, value: data.pps },
            { name: CurrentLang().treatment_summary_card_pulses, value: data.pulses },
            { name: CurrentLang().treatment_summary_card_duration, value: StringUtils.formatMinuteAndSeconds(data.duration) },
            { name: CurrentLang().treatment_summary_card_mode, value: data.mode }
        ];
    }

    render() {
        var pairs = this.getNamedValuePairs(this.props.data);

        // console.log('MagstimTreatmentSummary.render pairs=' + JSON.stringify(pairs));
        // console.log('MagstimTreatmentSummary.render props=' + JSON.stringify(this.props.data));
        // console.log('MagstimTreatmentSummary.render stimguideLocations=' + JSON.stringify(this.props.stimguideLocations));

        return (
            <Wrapper className="col">
                <Row className="pt-2 pb-2 ml-2">
                    <Col sm="12" md="4" className="mt-4">
                        <MagstimPropertyCard title={this.props.data.name} listitems={pairs} />
                    </Col>

                    <Col sm="12" md={{ offset: 1, size: 7 }} className="mt-4">                              
                        <InputGroup size={CurrentTheme().ControlSize}>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{CurrentLang().treatment_summary_manual_location}</InputGroupText>
                            </InputGroupAddon>
                            <Input innerRef={this._inputManualLocation} defaultValue={this.state.name} onChange={this.onChangeManualLocation} type="text" placeholder={CurrentLang().treatment_summary_manual_location} style={styles.magstimFormControl} />
                        </InputGroup>
            
                        <InputGroup size={CurrentTheme().ControlSize}>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{CurrentLang().treatment_summary_stimguide_location}</InputGroupText>
                            </InputGroupAddon>
                            <MagstimDropdown ref={this._dropdownStimGuideLocation} onSelect={this.onChangeStimGuideLocation} disabled={!this.props.stimguideLocationsEnabled} size={CurrentTheme().ControlSize}>
                                {
                                    Object.keys(this.props.stimguideLocations).map((key, index) => (
                                        <DropdownItem id={index}
                                            key={'MagstimTreatmentSummary-' + key + '-' + index}
                                            active={index === 0}
                                        >{this.props.stimguideLocations[index]}</DropdownItem>
                                    ))
                                }
                            </MagstimDropdown>
                        </InputGroup>
                                   
                    </Col>
                </Row>
            </Wrapper>
        );
    }
}

MagstimTreatmentSummary.propTypes = {
    onChangeManualLocation: PropTypes.func,
    onChangeStimGuideLocation: PropTypes.func,
    index: PropTypes.number,
    data: PropTypes.object,
    stimguideLocations: PropTypes.array,
    stimguideLocationsEnabled: PropTypes.bool
};

MagstimTreatmentSummary.defaultProps = {
    onChangeManualLocation: undefined,
    onChangeStimGuideLocation: undefined,
    index: undefined,
    data: undefined,
    stimguideLocations: undefined,
    stimguideLocationsEnabled: false
};


const Wrapper = styled.section`

.input-group-prepend {
	width: 30%;
	justify-content: flex-end;

	.input-group-text {
		color: ${ MagstimColor.MagstimWhite};
		font-weight: 600;
		background-color: transparent;
		border: none;
		border-radius: .25rem;
	}
}

.input-group-append {
	.input-group-text {
		color: ${ MagstimColor.MagstimWhite};
		background-color: ${ MagstimColor.MagstimTextBackground};
		border: 1px solid ${ MagstimColor.MagstimTextBackground};
		border-radius: .25rem;
	}
}

.input-group>.custom-select:not(:first-child), .input-group>.form-control:not(:first-child) {
	border-radius: .25rem;
}

  
`;

export default MagstimTreatmentSummary;